<template>
  <div class="page3 content" style="width:100%;overflow: auto;padding:0;">
    <el-row style="margin:0;height:4vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark" style="height:4vh;display: flex;align-items: center;align-content: center;padding-left: 0.5vw">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>实名制上传统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin:0 0 1vh;">
      <el-col :span="6">
        <el-card class="box-card" @click.native="detail(1)">
          <p class="text item">上传参建班组</p>
          <div class="card-con">
            <div class="card-num color1">
              <span>{{upNum.upJoin}}个</span>
            </div>
            <img src="../../assets/image/upLoadData.png" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card" @click.native="detail(3)">
          <p class="text item">今日新增</p>
          <div class="card-con">
            <div class="card-num color1">
              <span>{{upNum.addJoin}}个</span>
            </div>
            <img src="../../assets/image/todayUp.png" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card" @click.native="dePerson(0)">
          <p class="text item">上传人员</p>
          <div class="card-con">
            <div class="card-num color1">
              <span>{{upNum.upPerson}}人</span>
            </div>
            <img src="../../assets/image/all.png" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="box-card" @click.native="dePerson(1)">
          <p class="text item">今日新增人员</p>
          <div class="card-con">
            <div class="card-num color1">
              <span>{{upNum.nowPerson}}人</span>
            </div>
            <img src="../../assets/image/newDay.png" />
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin:1vh 0;">
      <el-col :span="24" class="char-vis-line">
        <el-card class="box-card">
          人员上传月统计
          <el-select class="month-cir txt-year" v-model="year" @change="changeYear">
            <el-option
              v-for="item in groups"
              :key="item.year"
              :label="item.year"
              :value="item.year"
            ></el-option>
          </el-select>
          <div class="echart">
            <div id="page3Chart2" :style="{ height: '300px' }"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin:1vh 0;">
      <el-col :span="24" class="char-vis-line">
        <el-card class="box-card">
          上传劳务出勤每日统计
          <el-select class="month-cir txt-year" v-model="getTime" @change="changeTime">
            <el-option
              v-for="item in groups3"
              :key="item.getTime"
              :label="item.getTime"
              :value="item.getTime"
            ></el-option>
          </el-select>
          <div class="echart">
            <div id="page3Chart3" :style="{ height: '300px' }"></div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin:1vh 0;">
      <el-col :span="8">
        <el-card class="box-card" @click.native="detail(2)">
          <p class="text item">未上传班组</p>
          <div class="card-con">
            <div class="card-num color1">
              <span>{{upNum.noUpTeam}}个</span>
            </div>
            <img src="../../assets/image/upLoadData.png" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card" @click.native="dePerson(2)">
          <p class="text item">未上传人员</p>
          <div class="card-con">
            <div class="card-num color1">
              <span>{{upNum.noUpPerson}}个</span>
            </div>
            <img src="../../assets/image/newDay.png" />
          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card" @click.native="dePerson(3)">
          <p class="text item">未上传人员考勤</p>
          <div class="card-con">
            <div class="card-num color2">
              <span>{{upNum.noAttend}}人</span>
            </div>
            <img src="../../assets/image/unKnow.png" />
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
import echarts from 'echarts' //引入echarts

export default {
  name: 'eCharts',
  data() {
    return {
      inputInfo: {
        jsdw: '',
        lxr: '',
        lxnum: '',
        sgdw: '',
        xmjl: '',
        xmnum: '',
        sgxk: ''
      },
      upNum: {
        upJoin: 0, //上传参建班组
        addJoin: 0, //今日新增
        upPerson: 0, //上传班组人员
        nowPerson: 0, //今日上传
        noUpTeam: 0, //未上传班组
        noUpPerson: 0, //未上传人员
        noAttend: 0 //未上传人员考勤
      },
      groupId: '',
      groups: [
        {
          year: new Date().getFullYear()
        },
        {
          year: new Date().getFullYear() - 1
        },
        {
          year: new Date().getFullYear() - 2
        },
        {
          year: new Date().getFullYear() - 3
        }
      ],
      year: new Date().getFullYear(),
      // 年加月
      groups3: [
        {
          getTime: new Date().getFullYear() + '-' + '01'
        },
        {
          getTime: new Date().getFullYear() + '-' + '02'
        },
        {
          getTime: new Date().getFullYear() + '-' + '03'
        },
        {
          getTime: new Date().getFullYear() + '-' + '04'
        },
        {
          getTime: new Date().getFullYear() + '-' + '05'
        },
        {
          getTime: new Date().getFullYear() + '-' + '06'
        },
        {
          getTime: new Date().getFullYear() + '-' + '07'
        },
        {
          getTime: new Date().getFullYear() + '-' + '08'
        },
        {
          getTime: new Date().getFullYear() + '-' + '09'
        },
        {
          getTime: new Date().getFullYear() + '-' + '10'
        },
        {
          getTime: new Date().getFullYear() + '-' + '11'
        },
        {
          getTime: new Date().getFullYear() + '-' + '12'
        }
      ],
      getTime: '' //当前
    }
  },
  mounted() {
    if (util.session.get('roleId') != '4') {
      this.groupId = util.session.get('proId')
    } else {
      this.groupId = util.session.get('groupId')
    }
    var getDate = new Date().getMonth() + 1
    getDate = getDate < 10 ? '0' + getDate : getDate
    this.getTime = new Date().getFullYear() + '-' + getDate
    this.getData()
    //this.getJoinTeam()
    this.findAttendByYearAndMonth()
    this.findAttendByYearAndMonth1()
    this.getAttendCount()
  },
  methods: {
    // 获取数据
    getData() {
      // 数据上传
      let that = this
      myHttp.secUploadShiftAndPersonCount({
          projectId: this.groupId
      }).then(function(resp) {
        if (resp.data.code == '200') {
          var data = resp.data.data
          that.upNum.upJoin = data.shift.allUploadShift || 0
          that.upNum.addJoin = data.shift.todayUploadShift || 0
          that.upNum.upPerson = data.shiftPerson.allUploadShiftPerson || 0
          that.upNum.nowPerson = data.shiftPerson.todayUploadShiftPerson || 0
          that.upNum.noUpTeam = data.shift.noUploadShift || 0
          that.upNum.noUpPerson = data.shiftPerson.noUploadShiftPerson || 0
          // that.upNum.noAttend =
          //   data.shiftPerson.noUploadShiftPersonAttend || 0
        }
      })
    },
    changeTime(e) {
      this.getTime = e
      this.findAttendByYearAndMonth1()
    },
    changeYear(e) {
      this.year = e
      this.findAttendByYearAndMonth()
    },
    //获取参建班组列表
    // getJoinTeam() {
    //   var that = this
    //   myHttp.findUploadTeamsPersonCount({
    //       projectId: this.groupId
    //   }).then(function(resp) {
    //       if (resp.data.code == '200') {
            
    //       }
    //     })
    // },
    // 人员上传月统计接口
    findAttendByYearAndMonth() {
      var that = this
      myHttp.findAttendByYearAndMonth({
          projectId: this.groupId,
          time: this.year,
          perTimeFlag: 1
      }).then(function(resp) {
          if (resp.data.code == '200') {
            that.setChart2(resp.data.data.manager, resp.data.data.worker)
          }
        })
    },
    // 每日出勤接口
    findAttendByYearAndMonth1() {
      var that = this
      myHttp.findAttendByYearAndMonth({
          projectId: this.groupId,
          time: this.getTime,
          perTimeFlag: 2
      }).then(function(resp) {
        if (resp.data.code == '200') {
          that.setChart3(resp.data.data.AllNum)
        }
      })
    },
    //上传参建班组
    setChart1(data) {
      var page3Chart1 = this.$echarts.init(
        document.getElementById('page3Chart1')
      )
      page3Chart1.setOption({
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },

        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          z: 2,
          style: {
            text: '1650人',
            x: 100,
            y: 100,
            textAlign: 'center',
            fill: '#1B3BF5',
            height: 30,
            fontSize: 18,
            fontWeight: 'bold'
          }
        },
        series: [
          {
            name: '访问来源',
            type: 'pie',

            radius: ['42%', '64%'],
            hoverAnimation: false,
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ['#4D7BF4', '#4ECBFF', '#F3AF90']
                  return colorList[params.dataIndex]
                }
              }
            },
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true,
                position: 'outside',
                formatter: '{b}\n{c}人',
                textStyle: {
                  fontSize: '12',
                  fontWeight: 'bold'
                },
                emphasis: {
                  show: true
                }
              }
            },
            labelLine: {
              show: true
            },
            data: [
              { value: 1500, name: '工人人数' },
              { value: 156, name: '管理人数' }
            ]
          }
        ]
      })
    },

    // 人员上传月统计
    setChart2(manger, woker) {
      var option = {
        grid: {
          left: '1%',
          right: '1%',
          top: '10%',
          bottom: '5%',
          containLabel: true
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          //show: true,   //default true
          showDelay: 0, //显示延时，添加显示延时可以避免频繁切换
          hideDelay: 50, //隐藏延时
          transitionDuration: 0, //动画变换时长
          backgroundColor: 'rgba(0,0,0,0.7)', //背景颜色（此时为默认色）
          borderRadius: 8, //边框圆角
          padding: 10, // [5, 10, 15, 20] 内边距
          position: function(p) {
            // 位置回调
            // console.log && console.log(p);
            return [p[0] + 10, p[1] - 10]
          }
        },
        color: ['#886CFF', '#17B2FE'],
        legend: {
          show: true,
          icon: 'circle',
          data: ['工人出勤', '管理出勤'],
          top: '-1%',
          right: '0%',
          textStyle: {
            fontSize: 12,
            color: '#999'
          }
        },
        xAxis: {
          type: 'category',
          data: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
          ],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#1B3BF5',
              fontWeight: 'Bold'
            }
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          // max: 500,
          // interval: 500,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          }
        },
        series: [
          {
            name: '工人出勤',
            data: woker,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 4,
                  color: '#886CFF'
                }
              }
            },
            smooth: true
          },
          {
            name: '管理出勤',
            data: manger,
            type: 'line',
            symbol: 'none',
            itemStyle: {
              normal: {
                barBorderRadius: 0,
                lineStyle: {
                  width: 4,
                  color: '#17B2FE'
                }
              }
            },
            smooth: true
          }
        ]
      }
      var page = this.$echarts.init(document.getElementById('page3Chart2'))
      page.setOption(option)
    },
    // 劳务统计  eChart3
    setChart3(AllNum) {
      var option = {
        color: ['#3398DB'],
        tooltip: {
          show: true,
          trigger: 'axis',
          //show: true,   //default true
          showDelay: 0, //显示延时，添加显示延时可以避免频繁切换
          hideDelay: 50, //隐藏延时
          transitionDuration: 0, //动画变换时长
          backgroundColor: 'rgba(0,0,0,0.9)', //背景颜色（此时为默认色）
          borderRadius: 8, //边框圆角
          padding: 10, // [5, 10, 15, 20] 内边距
          position: function(p) {
            // 位置回调
            // console.log && console.log(p);
            return [p[0] + 10, p[1] - 10]
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '0%',
          top: '15%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [
              '1日',
              '2日',
              '3日',
              '4日',
              '5日',
              '6日',
              '7日',
              '8日',
              '9日',
              '10日',
              '11日',
              '12日',
              '13日',
              '14日',
              '15日',
              '16日',
              '17日',
              '18日',
              '19日',
              '20日',
              '21日',
              '22日',
              '23日',
              '24日',
              '25日',
              '26日',
              '27日',
              '28日',
              '29日',
              '30日',
              '31日'
            ],
            axisTick: {
              show: false,
              alignWithLabel: true
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: '#1B3BF5',
                fontWeight: 'Bold'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            // min: 1,
            // max: 100,
            // interval: 10,
            splitArea: {
              // show: true  灰白背景
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '今日出勤',
            type: 'bar',
            barWidth: '18%',
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: '#30B4EF'
                  },
                  {
                    offset: 1,
                    color: '#C8EBFB'
                  }
                ])
              }
            },
            data: AllNum
          }
        ]
      }
      var page = this.$echarts.init(document.getElementById('page3Chart3'))
      page.setOption(option)
    },
    //
    // secUploadShiftAndPersonNoAttendCount
    // 未上传考勤人员数量
    getAttendCount() {
      var that = this
      myHttp
        .secUploadShiftAndPersonNoAttendCount({
          projectId: this.groupId
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            that.upNum.noAttend =
              resp.data.data.shiftPerson.noUploadShiftPersonAttend || 0
          }
        })
    },

    // 点击进入班组
    detail(index) {
      var status = index
      var that = this
      setTimeout(function() {
        that.$router.push({ name: 'teamDetail', params: { status: status } })
      }, 0)
    },
    // 点击进入班组人员详细
    dePerson(index) {
      var status = index
      var that = this
      setTimeout(function() {
        that.$router.push({ name: 'teamPerson', params: { status: status } })
      }, 0)
    }
  }
}
</script>

<style scope>
.page3 {
  width: 100%;
  height: 100%;
  position: relative;
  /* padding: 1vh; */
}

.page3 .inputLis div .el-input__inner {
  height: 40px;
  border: 0 none;
  font-size: 16px;
  color: #707070;
}

.page3 .el-row {
  margin-top: 20px;
  border-radius: 4px;
}

.page3 .el-row:last-child {
  margin-bottom: 30px;
}

/* .page3 .el-row:nth-child(3) .el-col .el-card,
.page3 .el-row:nth-child(4) .el-col .el-card {
  height: 360px;
} */

.page3 .echart-pie {
  margin-left: -20px;
  margin-top: 20px;
}

.text {
  font-size: 16px;
}

.page3 .item {
  position: absolute;
  left: 18px;
  top: -5px;
  padding: 18px 0;
}

.page3 .item-bot {
  position: absolute;
  left: 26px;
  bottom: 0px;
  padding: 15px 0;
  font-size: 16px;
  color: #ffbc01;
}

.page3 .box-card {
  position: relative;
  padding: 10px;
}

.page3 .month-pie,
.page3 .month-cir {
  position: absolute;
  top: 20px;
  left: 25px;
  font-size: 18px;
  font-weight: bold;
  color: #707070;
}

.page3 .month-pie i,
.page3 .month-cir i {
  margin-left: 8px;
}

.card-con {
  height: 70px;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.card-num {
  width: 60%;
  padding: 18px;
}

.card-num span {
  font-size: 30px;
  color: #1b3bf5;
  font-weight: bold;
  cursor: pointer;
}

.card-num img {
  top: -7px;
  position: relative;
}

.color1 span {
  color: #4ecbff;
}

.color2 span {
  color: #ffbc01;
}

.inputLis {
  display: flex;
  margin-top: 28px;
  margin-bottom: 20px;
  margin-left: 20px;
}

.inputLis div {
  display: flex;
}
/* 
.inputLis div .el-button {
  position: absolute;
  left: 500px;
  bottom: 480px;
} */

.inputLis div span {
  width: 180px;
  line-height: 40px;
  font-size: 18px;
  text-align: left;
  margin-left: 40px;
}

.el-row .form-btn {
  position: absolute;
  left: 1000px;
  bottom: 50px;
  background-color: #4ecbff;
  border: 0 none;
}

.page2 .month-pie,
.page2 .month-cir {
  position: absolute;
  top: 20px;
  left: 25px;
  font-size: 18px;
  font-weight: bold;
  color: #707070;
}

.txt-year {
  width: 110px;
}
.month-cir .el-input__inner {
  border: 0 none;
  height: auto;
  line-height: 20px;
  font-size: 18px;
  padding: 0;
}

.month-cir .el-input__suffix {
  right: 12px;
}

.month-cir .el-input--suffix .el-input__inner {
  padding-right: 0;
  height: auto;
}

.month-cir .el-select .el-input__inner {
  padding-right: 0;
}

.month-cir .el-input__icon {
  height: auto;
  line-height: 20px;
}
</style>